"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CLUSTER_MAP = exports.PROGRAM_IDS = void 0;
const web3_js_1 = require("@solana/web3.js");
const vault_core_1 = require("@castlefinance/vault-core");
__exportStar(require("./adapters"), exports);
__exportStar(require("./client"), exports);
__exportStar(require("./types"), exports);
__exportStar(require("./utils"), exports);
exports.PROGRAM_IDS = {
    [vault_core_1.DeploymentEnvs.devnetStaging]: new web3_js_1.PublicKey("4tSMVfVbnwZcDwZB1M1j27dx9hdjL72VR9GM8AykpAvK"),
    [vault_core_1.DeploymentEnvs.devnetParity]: new web3_js_1.PublicKey("Cast1eoVj8hwfKKRPji4cqX7WFgcnYz3um7TTgnaJKFn"),
    [vault_core_1.DeploymentEnvs.mainnet]: new web3_js_1.PublicKey("Cast1eoVj8hwfKKRPji4cqX7WFgcnYz3um7TTgnaJKFn"),
};
exports.CLUSTER_MAP = {
    [vault_core_1.DeploymentEnvs.devnetStaging]: vault_core_1.Clusters.devnet,
    [vault_core_1.DeploymentEnvs.devnetParity]: vault_core_1.Clusters.devnet,
    [vault_core_1.DeploymentEnvs.mainnet]: vault_core_1.Clusters.mainnetBeta,
};
//# sourceMappingURL=index.js.map